import Cookies from 'js-cookie'
import { Check } from 'react-feather'
import { useAuth } from 'src/lib/contexts/AuthContext'
import { useCheckoutUI } from 'src/lib/contexts/CheckoutUIContext'
import { postRequest } from 'src/lib/core/api-client'
import { OrganisationType, UserDataType } from 'src/lib/types/user'
import { apiURI, constants } from 'src/lib/utils/constants'
import { classNames, refresh } from 'src/lib/utils/helpers'
import LogoWithFallback from 'src/components/common/LogoWithFallback'
import { errorToast } from 'src/lib/utils/toasters'
import { useLocale } from 'src/lib/hooks/useLocal'

interface StoreListItemProps {
  organization: OrganisationType
  isSelected: boolean
}

const StoreListItem = ({ organization, isSelected }: StoreListItemProps) => {
  const { login } = useAuth()
  const { t } = useLocale()
  const {
    getters: { checkoutUI }
  } = useCheckoutUI()
  const logoUrl = checkoutUI?.logoUrl ?? ''

  const handleStoreSwitch = async (storeId: string) => {
    if (!storeId) return

    try {
      let response: any = await postRequest(`/merchant-user/organization/${storeId}/switch`, apiURI.AUTH_ENGINE, {})
      response = response?.data?.data
      const {
        access_token: authToken,
        access_token_expires_at: authTokenExpiry,
        refresh_token: refreshToken,
        refresh_token_expires_at: refreshTokenExpiry
      } = response || {}

      const userData = Cookies.get(constants.FLO_USER_DATE)
      const userObject: UserDataType = JSON.parse(userData ?? '{}')

      login({
        idToken: authToken,
        email: userObject.email,
        name: userObject.name,
        refreshToken: refreshToken,
        authExpiry: authTokenExpiry,
        refreshExpiry: refreshTokenExpiry,
        intercomToken: response?.intercom_jwttoken
      })
      refresh()
    } catch (e: any) {
      const errorMessage = e?.data?.error?.message || t('something_went_wrong')
      errorToast(errorMessage)
      console.error('Store switch error:', e)
    }
  }

  return (
    <div
      className={classNames(
        'flex items-center gap-2 px-2 py-1.5 rounded-md cursor-pointer hover:bg-zinc-950/5 ',
        isSelected ? 'bg-indigo-500/10' : ''
      )}
      onClick={() => handleStoreSwitch(organization.merchantId)}
    >
      <LogoWithFallback
        logoUrl={isSelected ? logoUrl : ''}
        fallbackText={organization.name.charAt(0)?.toUpperCase() || ''}
        id={`store-${organization.merchantId}`}
      />
      <div className='flex justify-between items-center w-full'>
        <p className='text-text-sm-regular  text-zinc-800 '>{organization.name}</p>
        {isSelected && <Check size={16} className='text-indigo-500' />}
      </div>
    </div>
  )
}

export default StoreListItem
